import { StatusAssessment } from '@/swagger/constants/reports-enums';

// TODO: temp mocked CSV
const CSV_MOCK =
  'id;firstName;lastName;role;department\n1;Alice;Rossi;Software Engineer;Engineering\n2;Marco;Bianchi;Product Manager;Product\n3;Sara;Ferrari;UX Designer;Design\n4;Luca;Conti;Data Analyst;Engineering\n5;Giulia;Marino;HR Specialist;People\n';
export const MOCK_RESPONSE_GET_REPORT_ASSESSMENT_EXPORT: Blob = new Blob([CSV_MOCK], {
  type: 'text/csv',
});
export const MOCK_RESPONSE_GET_REPORT_TRAINING_EXPORT: Blob = new Blob([CSV_MOCK], {
  type: 'text/csv',
});

export const MOCK_RESPONSE_GET_REPORTS_ASSESSMENTS = {
  data: [
    {
      id: '1',
      firstName: 'Alice',
      lastName: 'Rossi',
      email: 'alice.rossi@example.com',
      userId: 'user-001',
      organizationId: 'org-001',
      companyArea: 'Engineering',
      companyAreaKey: 'engineering',
      companyDepartment: 'Frontend',
      companyDepartmentKey: 'frontend',
      companyRole: 'Software Engineer',
      companyRoleKey: 'software_engineer',
      type: 'SOFT_SKILLS',
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-03-20T12:30:00Z',
      assessment: {
        status: StatusAssessment.FINISHED,
        timestamp: '2024-03-20T12:30:00Z',
      },
      result: [
        {
          metric: { id: 'M1', name: 'Communication' },
          score: 4.2,
        },
        {
          metric: { id: 'M2', name: 'Teamwork' },
          score: 3.8,
        },
      ],
    },
    {
      id: '2',
      firstName: 'Marco',
      lastName: 'Bianchi',
      email: 'marco.bianchi@example.com',
      userId: 'user-002',
      organizationId: 'org-001',
      companyArea: 'Product',
      companyAreaKey: 'product',
      companyDepartment: 'Product Management',
      companyDepartmentKey: 'product_management',
      companyRole: 'Product Manager',
      companyRoleKey: 'product_manager',
      type: 'HARD_SKILLS',
      createdAt: '2024-02-10T09:00:00Z',
      updatedAt: '2024-04-05T11:00:00Z',
      assessment: {
        status: StatusAssessment.SENT,
        timestamp: '2024-04-05T11:00:00Z',
      },
      result: [],
    },
    {
      id: '3',
      firstName: 'Sara',
      lastName: 'Ferrari',
      email: 'sara.ferrari@example.com',
      userId: 'user-003',
      organizationId: 'org-001',
      companyArea: 'Design',
      companyAreaKey: 'design',
      companyDepartment: 'UX',
      companyDepartmentKey: 'ux',
      companyRole: 'UX Designer',
      companyRoleKey: 'ux_designer',
      type: 'SOFT_SKILLS',
      createdAt: '2024-01-20T14:00:00Z',
      updatedAt: '2024-03-15T16:45:00Z',
      assessment: {
        status: StatusAssessment.SENT,
        timestamp: '2024-03-15T16:45:00Z',
      },
      result: [],
    },
    {
      id: '4',
      firstName: 'Luca',
      lastName: 'Conti',
      email: 'luca.conti@example.com',
      userId: 'user-004',
      organizationId: 'org-001',
      companyArea: 'Engineering',
      companyAreaKey: 'engineering',
      companyDepartment: 'Data',
      companyDepartmentKey: 'data',
      companyRole: 'Data Analyst',
      companyRoleKey: 'data_analyst',
      type: 'HARD_SKILLS',
      createdAt: '2024-03-01T08:30:00Z',
      updatedAt: '2024-04-20T10:15:00Z',
      assessment: {
        status: StatusAssessment.FINISHED,
        timestamp: '2024-04-20T10:15:00Z',
      },
      result: [
        {
          metric: { id: 'M3', name: 'Problem Solving' },
          score: 4.1,
        },
        {
          metric: { id: 'M6', name: 'Analytical Thinking' },
          score: 4.6,
        },
      ],
    },
    {
      id: '5',
      firstName: 'Giulia',
      lastName: 'Marino',
      email: 'giulia.marino@example.com',
      userId: 'user-005',
      organizationId: 'org-001',
      companyArea: 'People',
      companyAreaKey: 'people',
      companyDepartment: 'HR',
      companyDepartmentKey: 'hr',
      companyRole: 'HR Specialist',
      companyRoleKey: 'hr_specialist',
      type: 'SOFT_SKILLS',
      createdAt: '2024-02-25T13:00:00Z',
      updatedAt: '2024-04-10T09:30:00Z',
      assessment: {
        status: StatusAssessment.FINISHED,
        timestamp: '2024-04-10T09:30:00Z',
      },
      result: [
        {
          metric: { id: 'M2', name: 'Teamwork' },
          score: 4.4,
        },
        {
          metric: { id: 'M1', name: 'Communication' },
          score: 4.8,
        },
      ],
    },
  ],
  totalItems: 5,
};

export const MOCK_RESPONSE_GET_REPORTS_TRAININGS = {
  data: [
    {
      id: '1',
      firstName: 'Alice',
      lastName: 'Rossi',
      email: 'alice.rossi@example.com',
      userId: 'user-001',
      organizationId: 'org-001',
      companyArea: 'Engineering',
      companyAreaKey: 'engineering',
      companyDepartment: 'Frontend',
      companyDepartmentKey: 'frontend',
      companyRole: 'Software Engineer',
      companyRoleKey: 'software_engineer',
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-03-20T12:30:00Z',
      completedContents: 8,
      contentsInProgress: 2,
      trainingTimeInMinutes: 750,
    },
    {
      id: '2',
      firstName: 'Marco',
      lastName: 'Bianchi',
      email: 'marco.bianchi@example.com',
      userId: 'user-002',
      organizationId: 'org-001',
      companyArea: 'Product',
      companyAreaKey: 'product',
      companyDepartment: 'Product Management',
      companyDepartmentKey: 'product_management',
      companyRole: 'Product Manager',
      companyRoleKey: 'product_manager',
      createdAt: '2024-02-10T09:00:00Z',
      updatedAt: '2024-04-05T11:00:00Z',
      completedContents: 6,
      contentsInProgress: 1,
      trainingTimeInMinutes: 540,
    },
    {
      id: '3',
      firstName: 'Sara',
      lastName: 'Ferrari',
      email: 'sara.ferrari@example.com',
      userId: 'user-003',
      organizationId: 'org-001',
      companyArea: 'Design',
      companyAreaKey: 'design',
      companyDepartment: 'UX',
      companyDepartmentKey: 'ux',
      companyRole: 'UX Designer',
      companyRoleKey: 'ux_designer',
      createdAt: '2024-01-20T14:00:00Z',
      updatedAt: '2024-03-15T16:45:00Z',
      completedContents: 10,
      contentsInProgress: 3,
      trainingTimeInMinutes: 900,
    },
    {
      id: '4',
      firstName: 'Luca',
      lastName: 'Conti',
      email: 'luca.conti@example.com',
      userId: 'user-004',
      organizationId: 'org-001',
      companyArea: 'Engineering',
      companyAreaKey: 'engineering',
      companyDepartment: 'Data',
      companyDepartmentKey: 'data',
      companyRole: 'Data Analyst',
      companyRoleKey: 'data_analyst',
      createdAt: '2024-03-01T08:30:00Z',
      updatedAt: '2024-04-20T10:15:00Z',
      completedContents: 14,
      contentsInProgress: 1,
      trainingTimeInMinutes: 1200,
    },
    {
      id: '5',
      firstName: 'Giulia',
      lastName: 'Marino',
      email: 'giulia.marino@example.com',
      userId: 'user-005',
      organizationId: 'org-001',
      companyArea: 'People',
      companyAreaKey: 'people',
      companyDepartment: 'HR',
      companyDepartmentKey: 'hr',
      companyRole: 'HR Specialist',
      companyRoleKey: 'hr_specialist',
      createdAt: '2024-02-25T13:00:00Z',
      updatedAt: '2024-04-10T09:30:00Z',
      completedContents: 0,
      contentsInProgress: 0,
      trainingTimeInMinutes: 0,
    },
  ],
  totalItems: 5,
};
